(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("luna-syntax-highlighter"));
	else if(typeof define === 'function' && define.amd)
		define(["luna-syntax-highlighter"], factory);
	else if(typeof exports === 'object')
		exports["LunaMarkdownViewer"] = factory(require("luna-syntax-highlighter"));
	else
		root["LunaMarkdownViewer"] = factory(root["LunaSyntaxHighlighter"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__156__) {
return 